























































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddReturn {
        id?: number;
        warehouseInfoId: number;
        returnTime?: Date;
        whetherHandle?: boolean;
        userCode: string;
        shipment?: string;
        reMark?: string;
        orderNumber: string;
        orderType: number;
    }
    @Component
    export default class CreatereturnorderModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        returnorderModel: AddReturn = new AddReturn();
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        warehouseOrderType = Enums.WarehouseOrderType;
        addLoding = false;
        amountTotal: string = '';;
        userCode: string = "";
        created() {
            this.getCity();
        }
        signFor() {
            this.save();
        }
        async check() {
            this.userCode = await this.$store.dispatch({
                type: 'orderreturn/getUserCode',
                data: { orderNumber: this.returnorderModel.orderNumber, warehouseInfoId :this.returnorderModel.warehouseInfoId}
            })
            this.returnorderModel.userCode = this.userCode;
        }
        save() {
            (this.$refs.returnCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'orderreturn/editOrderReturn',
                        data: this.returnorderModel
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.returnCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                    this.userCode = "";
                }
            })
        }
        async enter() {
            this.check();
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.returnorderModel.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }
        cancel() {
            (this.$refs.returnCreateForm as any).resetFields();
            this.$emit('input', false);
            this.userCode = "";
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        returnorderRule = {

            warehouseId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            userCode: [
                { required: true, message: '用户编码不能为空，', trigger: 'blur' }
            ],
            orderNumber: [
                { required: true, message: '订单号不能为空', trigger: 'blur' }
            ],
           
        };

    }
